var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-inquiry-statuslabel",class:[ _vm.computedValue ]},[_vm._v("\n  "+_vm._s(_vm.computedStatus)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }